<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          style="margin-left: 10px"
          @click="openDelete"
        >删除</el-button>
    </div>
    <!-- <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">编号</label>
        <el-input
          v-model="sn"
          placeholder="请输入编号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">语种</label>
        <el-input
          v-model="lang"
          placeholder="请输入语种"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div> -->
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 251px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="vipLevel" label="针对VIP等级" width="100" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="active" label-width="90px" size="mini">
        <el-form-item label="针对VIP等级">
          <el-input v-model="active.vipLevel" placeholder="针对VIP等级"/>
        </el-form-item>
        <!-- 奖项1 -->
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a1" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l1">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap1" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp1" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId1" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w1" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项2 -->
        <el-form-item label="奖项2" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a2" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l2">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap2" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp2" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId2" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w2" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项3 -->
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a3" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l3">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap3" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp3" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId3" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w3" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项4 -->
        <el-form-item label="奖项4" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a4" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l4">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                  购买
                  <el-input v-model="active.ap4" style="width: 60px;" placeholder=""/>
                 个升级包，升级包ID：
                  <el-input v-model="active.apId4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp4" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId4" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w4" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项5 -->
        <el-form-item label="奖项5" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a5" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l5">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap5" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp5" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId5" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w5" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项6 -->
        <el-form-item label="奖项6" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a6" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l6">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap6" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp6" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId6" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w6" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项7 -->
        <el-form-item label="奖项7" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a7" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l7">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap7" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp7" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId7" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w7" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项8 -->
        <el-form-item label="奖项8" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="active.a8" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l8">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="active.c8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="active.r8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="active.tr8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="active.v8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="active.tv8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="active.ap8" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="active.apId8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="active.cp8" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="active.cpId8" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w8" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >添加</el-button>
        </el-popconfirm>
        </el-form-item>

      </el-form>
    </el-dialog>
    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="900px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
    <!-- 表单 editForm-->
    <el-form ref="form" :model="editForm" label-width="90px" size="mini">
        <el-form-item label="针对VIP等级">
          <el-input v-model="editForm.vipLevel" placeholder="针对VIP等级"/>
        </el-form-item>
        <!-- 奖项1 -->
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a1" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l1">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap1" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId1" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp1" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId1" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w1" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项2 -->
        <el-form-item label="奖项2" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a2" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l2">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap2" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId2" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp2" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId2" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w2" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项3 -->
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a3" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l3">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap3" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId3" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp3" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId3" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w3" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项4 -->
        <el-form-item label="奖项4" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a4" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l4">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap4" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId4" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp4" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId4" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w4" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项5 -->
        <el-form-item label="奖项5" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a5" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l5">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap5" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId5" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp5" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId5" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w5" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项6 -->
        <el-form-item label="奖项6" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a6" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l6">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap6" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId6" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp6" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId6" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w6" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项7 -->
        <el-form-item label="奖项7" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a7" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l7">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap7" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId7" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp7" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId7" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w7" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <!-- 奖项8 -->
        <el-form-item label="奖项8" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div>
                <span style="margin-right: 10px;">USDT金额</span>
                <el-input v-model="editForm.a8" style="width: 160px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l8">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                邀请下级
                <el-input v-model="editForm.c8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                加入群聊
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人充值
                <el-input v-model="editForm.r8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="4">
                团队充值
                <el-input v-model="editForm.tr8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                邀请新VIP好友
               <el-input v-model="editForm.v8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                团队VIP人数
               <el-input v-model="editForm.tv8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                购买
               <el-input v-model="editForm.ap8" style="width: 60px;" placeholder=""/>
               个升级包，升级包ID：
               <el-input v-model="editForm.apId8" style="width: 60px;" placeholder=""/>
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                 下级购买
                  <el-input v-model="editForm.cp8" style="width: 60px;" placeholder=""/>
                  个升级包，升级包ID：
                  <el-input v-model="editForm.cpId8" style="width: 60px;" placeholder=""/>
              </el-radio>
            </el-radio-group> 
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="editForm.w8" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="update()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn:'',
      lang:'en',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dataTime:['',''],
      yifangId:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.edit_dialogVisible = true;
      // this.$nextTick(()=>{
      //   this.$refs.image.init(this.editForm.image)
      // })
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
        .drawConfigList(params)
        .then((res) => {
          this.tableData = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .drawConfigDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.active = {}
      this.active.t1 = 0
      this.active.t2 = 0
      this.active.t3 = 0
      this.active.t4 = 0
      this.active.t5 = 0
      this.active.t6 = 0
      this.active.t7 = 0
      this.active.t8 = 0
      
    },
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 添加用户
    bannerSave() {
          this.$api.operate
            .drawConfigSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 添加用户
    update() {
          this.$api.operate
            .drawConfigUpdate(this.editForm)
            .then((res) => {
              this.$message.success(res);
              this.edit_dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio-group{
    align-items: center;
}
.input{
    color: red !important;
}
::v-dee .el-radio{
  margin-bottom: 10px !important;
}
.flex{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    
}
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
